export default {"src":"/_next/static/media/pinbetaling.bf40c933.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};